import React, { useState } from 'react';
import { Grid, TextField, Button, Link, LinearProgress } from '@material-ui/core';
import { useForm } from 'react-hook-form';
import { Link as LinkRouter, useHistory, useParams } from 'react-router-dom';
import { useDispatch } from "react-redux";
import AuthService from '../../../services/AuthService';
import { showSnackBar } from '../../../redux/actions/ui';
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
  root: {
    marginTop: "5em",   
    [theme.breakpoints.down('sm')]: {
      marginTop: "1em",
    },
  }
}));

function Resetpassword() {
  const classes = useStyles();
  let history = useHistory();
  const { uid, token } = useParams();
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState();
  const dispatch = useDispatch();

  const { register, errors, handleSubmit, setError,  getValues } = useForm({
    validateCriteriaMode: "all",
    mode: "onChange"
  });

  const onSubmit = async data => {
    const {new_password, re_new_password} = data;    
    if(new_password !== re_new_password){
      setError("password", "notMatch", "please choose a different username");
    }else{
      Resetpassword(new_password, re_new_password);    
    }    
  };

  const Resetpassword = async (newPassword, reNewPassowrd) => {
    setLoading(true);
    try{      
      await AuthService.resetPassword(newPassword, reNewPassowrd, uid, token);           
      setLoading(false);
      setSuccess("Password changed!, you will be redirected.");
      dispatch(showSnackBar("Changed passwprd successfully!"));
      setTimeout(() => { 
        history.push('/auth/login');
      }, 4000)
    }catch (error) {
      const statusCode = error.response ? error.response.status : 0;
      if (statusCode === 400){
        const data = error.response.data;
        if ( data && data.new_password){
          setError("new_password", "new_password", data.new_password[0]);
        }
      }      
      dispatch(showSnackBar("An error occurred!", 'error'));        
      setLoading(false);
    }
  }

  return (
    <form noValidate autoComplete="off" onSubmit={handleSubmit(onSubmit)} className={classes.root}>                    
      <Grid item xs={12} style={ {marginTop: "2.4em"} }>
          <h2 style={ {textAlign: "center"} }>Reset password</h2>
          <TextField 
            name="new_password"
            label="Password"
            type="password"
            placeholder="*****"
            variant="filled"
            fullWidth={true}

            inputRef={register({ 
              required: true, 
              minLength: {
                value: 8,
                message: "Password must have at least 8 characters"
              }       
            })}
            error={errors.new_password ? true : false}
            helperText={errors.new_password ? errors.new_password.message : null}
          />
        </Grid>

        <Grid item xs={12} style={ {marginTop: "2.4em"} }>
          <TextField 
            name="re_new_password"
            label="Re type password"
            type="password"
            placeholder="*****"
            variant="filled"
            fullWidth={true}

            inputRef={register({ 
              required: true,
              validate: value => value ===  getValues().new_password || "The passwords do not match" })
            }
            error={errors.re_new_password ? true : false}
            helperText={errors.re_new_password ? errors.re_new_password.message : null}
          />
        </Grid>

        <Grid item xs
        ={12} style={ {marginTop: "0.5em"} }>
          <Link 
            component={LinkRouter}
            to={'/auth/login'}
            > 
            Back to login
          </Link>
        </Grid>

        <Grid item xs={12} style={ {marginTop: "0.5em"} }>
          <div style={{position: "relative", width: "100%"}}> 
            {!loading && success && <h4 style={ {top: "-1em", position: "relative"} }>{success}</h4>}                       
          </div>
        </Grid>

        <Grid item xs={12} style={ {marginTop: "3em"} }>
          {/* Loading */}
          {loading && <LinearProgress /> }

          <Button
            style={ { height: "3em", color: "white", textTransform: "none", fontSize: "1.3em", fontWeight: "bold"} }
            color="primary"
            disabled={loading}
            fullWidth={true}
            variant="contained"
            type="submit">
            Reset password
          </Button>                      
        </Grid>
    </form>
  )
}

export default Resetpassword;